import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class IconVariant extends BaseOption {
  static userInterfaceComponent = {
    label: "Variant",
    component: inspectorTools.SIMPLE_PICKER,
    props: {
      options: [
        { id: "primary", name: "Primary" },
        { id: "secondary", name: "Secondary" },
        { id: "error", name: "Error" },
        { id: "warning", name: "Warning" },
        { id: "light", name: "Light" },
        { id: "branded", name: "Branded" },
        { id: "subtle", name: "Subtle" },
      ],
    },
  };

  static defaultValue = "primary";
}
